/*
*
* File JS componente News Yacht 
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './list-news.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const listNews = () => {

    const context = document.querySelector('.list-news');
    if(!context) return;

    const loadMore = context.querySelector('#load-more');
    const newsContainer = context.querySelector('.list-news__wrapper');
    const loader = document.querySelector('#loader');

    if(!loadMore) return;
    
    loadMore.addEventListener('click', (e) => {
        e.preventDefault();
        loader.classList.add('active');
        const page = e.target.dataset.page;

        fetch(`/wp-json/immedia-api/v1/news/${page}?output=html`)
            .then(response => response.json())
            .then(data => {
                const htmlContent = data['items'].join('');
                
                newsContainer.insertAdjacentHTML('beforeend', htmlContent);
                
                const showLoadMore = data['load_more'] ?? false;
                if (!showLoadMore) {
                    loadMore.setAttribute('disabled', 'true');
                }
                
                // Update the data-page attribute to the next page
                e.target.dataset.page = parseInt(page) + 1;
                loader.classList.remove('active');
            })
            .catch(error => {
                console.error('Error fetching news:', error);
                loader.classList.remove('active');
            });
    });
    
}


export default listNews;

//--------------------------------------------------------------------//